var React = require('react');

function PlayButtonWhite (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(.561 .602)","fill":"none","fillRule":"evenodd"},[React.createElement("ellipse",{"stroke":"#FFF","cx":"36.439","cy":"35.421","rx":"36.439","ry":"35.421","key":0}),React.createElement("path",{"d":"M48.15 38.358L32.983 48.612a2.25 2.25 0 0 1-3.51-1.864V26.24a2.25 2.25 0 0 1 3.51-1.864L48.15 34.63a2.25 2.25 0 0 1 0 3.728z","fill":"#FFF","key":1})]));
}

PlayButtonWhite.defaultProps = {"width":"74","height":"72"};

module.exports = PlayButtonWhite;

PlayButtonWhite.default = PlayButtonWhite;
